export const education = [
    {
        school: 'McMaster University',
        degree: 'Bachelor of Technology',
        Years: '2024 - Present',
        awards: 'TBD'
    },
    {
        school: 'George Brown College',
        degree: 'Ontario College Advanced Diploma',
        Years: '2021 - 2024',
        awards: 'Dean\'s Honour List (Winter 2023/Fall 2023/Winter 2024)'
    },
    {
        school: 'White Oaks Secondary School',
        degree: 'Ontario Secondary School Diploma',
        Years: '2017 - 2019',
        awards: 'Honours Award (Winter 2019)'
    },
];